import extractCollection from "shared-lib/data/graphql/extractCollection";
import { fetchFromRecipeSpace } from "shared-lib/data/graphql/fetchGraphQL";

import { GetRecipe } from "./queries";

type Props = {
  slug?: string;
  preview?: boolean;
  exclude?: string[];
  tags?: string[];
};

export default async function getRecipe({
  slug = "",
  exclude = [],
  preview = false,
  tags = [],
}: Props): Promise<Recipe> {
  const where: any = {};
  if (slug) {
    where.slug = slug;
    tags.push(slug);
  }
  if (exclude.length) {
    where.slug_not_in = exclude;
  }
  const fetchResponse = await fetchFromRecipeSpace(
    {
      query: GetRecipe,
      variables: {
        where,
        preview,
      },
    },
    ["GetRecipe", ...tags],
  );
  return extractCollection(fetchResponse)?.items[0];
}
